/**
 * Canonical statuses normalised by PPS, not any one provider's vocabulary.
 * Highnote emits these already; Stripe's active/inactive/canceled are mapped
 * onto them at the provider boundary.
 */
export enum CardStatus {
  ACTIVATION_REQUIRED = "ACTIVATION_REQUIRED",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  CLOSED = "CLOSED",
}

function isCardStatus(status: string): status is CardStatus {
  return Object.values(CardStatus).includes(status as CardStatus);
}

/**
 * Converts a status string from the API to a CardStatus.
 * Returns null for anything unrecognised so a new provider value degrades to a
 * missing badge rather than throwing from a render path.
 */
export function getCardStatus(status: string): CardStatus | null {
  return isCardStatus(status) ? status : null;
}
